export default {
  methods: {
    async showLoading(message="Loading...") {
      let loading = await this.$ionic.loadingController.create({
        message: message
      });
      loading.present();
      return loading;
    },
    async showToast(message, duration=3000) {
      let toast = await this.$ionic.toastController.create({
        message: message,
        duration: duration
      });
      toast.present();
    },
    async showAlert(title, message, buttons=["OK"]) {
      let alert = await this.$ionic.alertController.create({
        header: title,
        message: message,
        buttons: buttons
      });
      alert.present();
      return alert;
    },
    async showWarning(error) {
      if (error.response){
        console.warn(error.response);
      } 
      else if (error.request) {
        console.warn(error.request);
      }
      else if (error.message) {
        console.warn(error.message);
      }
      else {
        console.warn(error);
      }
      let message = this.errorMessage(error);
      return await this.showToast(message);
    },
    async showError(title, error) {
      if (error.response) {
        console.error("Response", error.response.data);
        console.error("Headers", error.response.headers);
      }
      else if (error.request) {
        console.error("Request", error.request);
      }
      else if (error.message) {
        console.error(title, error.message);
      }
      else {
        console.error(title, error);
      }
      let message = this.errorMessage(error);
      return await this.showAlert(title, message);
    },
    async showRetry(title, error, retry) {
      if (error.response) {
        console.error("Response", error.response.data);
        console.error("Headers", error.response.headers);
      }
      else if (error.request) {
        console.error("Request", error.request);
      }
      else {
        console.error(title, error.message);
      }
      let buttons = [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary'
        },
        {
          text: 'Retry',
          handler: () => {
            retry();
          },
        },
      ];
      let message = this.errorMessage(error);
      return await this.showAlert(title, message, buttons);
    },
    async showModal(component, params={}) {
      let modal = await this.$ionic.modalController.create({ 
        component: component,
        componentProps: {
          propsData: params
        },
        backdropDismiss: false
      });
      modal.present();
      return modal;
    },
    async hideModal(params={}) {
      await this.$ionic.modalController.dismiss(params);
    },
    showPage(route) {
      this.$router.push({ path:route });
    },
    hidePage() {
      this.$router.go(-1);
    },
    showRootPage(name) {
      this.$router.replace(name);
    },
    closeMenu() {
      this.$ionic.menuController.close();
    },
    openUrl(url) {
      window.open(url, "_blank");
    },
    openEmail(email) {
      window.open(`mailto:${email}`, "_blank");
    },
    openPhone(telephone) {
      window.open(`tel:${telephone}`, "_blank");
    },
    errorMessage(error) {
      if (error && error.result && error.result.error && error.result.error.message) {
        return error.result.error.message;
      }
      if (error && error.response && error.response.error && error.response.error.message) {
        return error.data.response.message;
      }
      if (error && error.response && error.response.data && error.response.data.error && error.response.data.error.message) {
        return error.response.data.error.message;
      }
      if (error && error.error && error.error.message) {
        return error.error.message;
      }
      if (error && error.message) {
        return error.message;
      }
      if (error && error.error) {
        return error.error;
      }
      return JSON.stringify(error);
    },
    expiredToken(error) {
      return error && error.response && error.response.status === 401;
    }
  }
};